import BatteryAlert from './BatteryAlert';

export default BatteryAlert;
